import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
};

const appsettingSlice = createSlice({
  name: "appsetting",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload.isLoading;
    },
  },
});

export const { setLoading } = appsettingSlice.actions;
export default appsettingSlice.reducer;
